export enum BracketLocation {
  ENDS = 'ends',
  ONE_CENTRALIZED = 'one_centralized',
}
